
<!--
  Footer bar
-->

<template lang="html">
  <footer id="footer">

    <div class="container">
      <div class="row">
        <div class="col-xs-7">
         <!--  <object class="footer-logo" data="static/img/common/logo_header_black.svg" type="image/svg+xml"></object> -->
          <img class="footer-logo" src="static/img/common/logo.svg" type="image/svg+xml" />
           <label><strong>CREATIVE FOOD INDULGENCE</strong><br/>©Room Service 2020</label>
        </div>

        <div class="col-xs-5 footer-social-icons">
          <ul>
            <li><a v-bind:href="contact.email_link" target="_blank"><img class="social-icon" :src="'static/img/common/'+ contact.email_icon_light" type="image/svg+xml" /></a></li>
            <li><a v-bind:href="contact.instagram_link" target="_blank"><img class="social-icon social-icon-insta" :src="'static/img/common/'+ contact.instagram_icon_light" type="image/svg+xml" /></a></li>
            <li><a v-bind:href="contact.phone_link" target="_blank"><img class="social-icon" :src="'static/img/common/'+ contact.phone_icon_light" type="image/svg+xml" /></a></li>
            
          </ul>
        </div>
  
      </div>
    </div>
</footer>

</template>

<script>
import {contact} from '../../content.json'

export default {
  name: 'footbar',
  data: function () {
    return {
      contact
    }
  }
}

</script>

<style>
  
  footer {
/*    border-top: 1px solid rgba(246,217,211,1);*/
    padding: 32px 0;
    padding-bottom: 40px;
  }
  footer p {
    line-height: 16px;
    margin-top: 10px;
  }
  footer span {
    font-size: 18px;
    margin-top: 86px;
    float: right;
  }
  .footer-bar {
    width: 100%;
    position: absolute; 
    top:0;
  }
  .footer-block {
    width:20%;
    height: 5px;
    float: left;
  }

  .footer-logo {
    max-width:100px;
    height:auto;
    fill: #000;
    display: block;
  }
  .footer-logo path {
    fill: #000!important;
  }


  .footer-social-icons ul {
    margin: 10px auto;
    padding: 0;
    text-align: center;
    list-style: none;
    text-align: right
  }

  .footer-social-icons li {
    display: inline-block;
    list-style: none;
  }

  .footer-social-icons li {

    text-align: center;
  }

  .footer-social-icons li a {
    
  }
  .footer-social-icons .social-icon {
    background-color: #fff;
    border: 1px solid #d1a699;
    height: 30px;
    width: 30px;
    padding: 7px;
    -webkit-transition: 0.2s ease-in-out;
    transition: 0.2s ease-in-out;
  }
  .social-icon-insta {
/*    padding: 7px!important;*/
  }

  .no-touch-device .footer-social-icons .social-icon:hover {
    background-color: rgba(209,166,153,0.2);

  }

  .footer-social-icons .social-icon:active {
    background-color: rgba(209,166,153,0.4);
  }

  footer label {
    margin: 10px 0;
  }

@media (min-width: 768px) {
  .footer-social-icons ul {
    text-align: right;
    margin: 0 auto;
  }
  footer {
    padding-bottom: 80px;
  }
}

@media (max-width: 374px) {
  .footer-social-icons .social-icon {
    height: 24px;
    width: 24px;
    padding: 4px;
  }
}


</style>



// WEBPACK FOOTER //
// Footbar.vue?102c85cc